import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Config from '../../config/Config';
import { withRouter } from 'react-router';
import { LSRW } from '../../utils/const';
import { appendScript } from '../../utils/appendScript';
import { removeScript } from '../../utils/removeScript';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';

const Status = ({
	completedPercent,
	description,
	video,
	domain,
	learningOutcomes,
	imageUrl,
}) => {
	const [showCourseDetails, setShowCourseDetails] = useState(false);
	useEffect(() => {
		if (!!completedPercent) {
			appendScript('easypiechart');
			appendScript('easypiechart-data');
		}
		return () => {
			removeScript('easypiechart');
			removeScript('easypiechart-data');
		};
	}, [completedPercent]);

	var DomainList = [];

	if (typeof domain !== 'undefined') {
		DomainList = domain.split('|').map(function (key) {
			return (
				<li key={key}>
					<img src={Config.ASSETSPATH + 'img/' + LSRW[key] + '.png'} alt="" />
				</li>
			);
		});
	}

	let whatYouLearn = '';
	if (!!learningOutcomes) {
		whatYouLearn = learningOutcomes.split('|').map(function (key) {
			return <li key={key}>{key}</li>;
		});
	}

	return (
		<div className="row" style={{ marginBottom: '10px' }}>
			<div className="col-lg-12 col-xs-12 col-md-12">
				<Card>
					<Card.Header>
						<h4>About the Course</h4>
					</Card.Header>
					<Card.Body>
						{!!video ? (
							<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
								<iframe
									id="player"
									frameborder="0"
									allowfullscreen="1"
									width="250"
									title="YouTube video player"
									src="https://www.youtube.com/embed/N6fB1kbGxMs?&amp;modestbranding=1&amp;rel=0&amp;wmode=opaque"
								></iframe>
							</div>
						) : null}
						<div
							className={`${
								!!video ? 'col-lg-4 col-md-4' : ' col-lg-7 col-md-8'
							} col-sm-12 col-xs-12 col-lg-12 col-md-12 course-description `}
						>
							<p>{description}</p>
							<div>
								<h6>Skills Taught:</h6>
								<ul className="popup-icons">{DomainList}</ul>
							</div>

							{/*<div> <h6>Practice Questions:</h6>
                                        <b>96</b></div>
                                      <div>
                                        <h6>Video:</h6>
                                        <b>4 hours 52 minutes</b>
                                      </div>*/}
							<div
								className="click_details"
								onClick={() => setShowCourseDetails(true)}
							>
								Click for Details
							</div>
						</div>

						{/*About course popup begin*/}
						<Modal
							className="course_detail_popup"
							show={showCourseDetails}
							onHide={() => setShowCourseDetails(false)}
							backdrop={true}
							keyboard={false}
						>
							<Modal.Header closeButton>
								<h4 className="about_course_title">About the Course</h4>
							</Modal.Header>
							<Modal.Body size="lg">
								<div className="row">
									<div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
										{!!video ? (
											<iframe
												id="player"
												frameborder="0"
												allowfullscreen="1"
												width="300"
												height="200"
												title="YouTube video player"
												src="https://www.youtube.com/embed/N6fB1kbGxMs?&amp;modestbranding=1&amp;rel=0&amp;wmode=opaque"
											></iframe>
										) : null}
										<div className="course-description">
											<div>
												<h6>Skills Taught:</h6>
												<ul className="popup-icons">{DomainList}</ul>
											</div>
											<img
												src={imageUrl}
												className="img-responsive courseDetailImg"
												alt="courseimg"
											/>
										</div>
									</div>
									<div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 course-description">
										<p>{description}</p>
										<h4>What will you learn:</h4>
										<ul>{whatYouLearn}</ul>
									</div>
								</div>
							</Modal.Body>
						</Modal>
					</Card.Body>
				</Card>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		totalAttempts,
		completedPercent,
		completedElements,
		continueElementDetails,
		isCoachCourse,
		description,
		video,
		domain,
		learningOutcomes,
		courseType,
		imageUrl,
	} = state.rootReducer.myCourse;
	return {
		totalAttempts,
		completedPercent,
		completedElements,
		continueElementDetails,
		isCoachCourse,
		description,
		video,
		domain,
		learningOutcomes,
		courseType,
		imageUrl,
	};
};

export default withRouter(compose(connect(mapStateToProps))(Status));
